import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <section id="contact" className="py-24 px-6 bg-gradient-to-b from-white to-green-50/30">
      <div className="max-w-5xl mx-auto">
        {/* Main CTA Card */}
        <div className="glass-card rounded-3xl p-12 md:p-16 text-center reveal">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-foreground mb-6">
            Ready to Maximize Your <br />
            <span className="gradient-text">Farm Performance?</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
            Join over 250 progressive farmers who trust Bloom for premium poultry nutrition.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="/products"
              className="group inline-flex items-center justify-center gap-3 bg-primary text-primary-foreground px-8 py-4 rounded-full text-base font-bold hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl"
            >
              <span>View Products</span>
              <Icon name="ArrowRightIcon" size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 glass-card px-8 py-4 rounded-full text-base font-bold hover:bg-white transition-all"
            >
              <Icon name="UserGroupIcon" size={20} className="text-primary" />
              <span>Become a Distributor</span>
            </a>
          </div>

          {/* Contact Information */}
          <div className="pt-8 border-t border-border">
            <p className="text-sm font-semibold text-muted-foreground mb-4">Contact us directly:</p>
            <div className="flex flex-wrap items-center justify-center gap-6 text-base">
              <a href="tel:0777014115" className="inline-flex items-center gap-2 text-foreground hover:text-primary transition-colors font-medium">
                <Icon name="PhoneIcon" size={18} className="text-primary" />
                <span>0777 014 115</span>
              </a>
              <span className="text-muted-foreground">|</span>
              <a href="tel:0704846600" className="inline-flex items-center gap-2 text-foreground hover:text-primary transition-colors font-medium">
                <Icon name="PhoneIcon" size={18} className="text-primary" />
                <span>0704 846 600</span>
              </a>
              <span className="text-muted-foreground">|</span>
              <a href="mailto:info@bloomanimalfeeds.com" className="inline-flex items-center gap-2 text-foreground hover:text-primary transition-colors font-medium">
                <Icon name="EnvelopeIcon" size={18} className="text-primary" />
                <span>info@bloomanimalfeeds.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}